// extracted by mini-css-extract-plugin
export default {"root":"I7PZbC9ocBVVCMqBjRLD","overflow":"GtPXLhmuY7aT1W35o5W2","success":"pUaHCxqJelx8AvvUEpGy","placeHolderShimmer":"syDzZolhNL5wd3_UkCEB"};